export default "__VITE_ASSET__U9sh_5Y3__"